'use client'
import { useEffect } from 'react'

export default function Error({ 
  error, 
  reset 
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log l'erreur complète dans la console pour debug
    console.error('Route error:', error)
    console.error('Error stack:', error.stack)
    console.error('Error digest:', error.digest)
    console.error('Error message:', error.message)
    
    // Optionnel: envoyer l'erreur à un service de monitoring
    // Sentry.captureException(error)
  }, [error])

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <h1 style={{ color: '#dc2626', marginBottom: 16 }}>
        Une erreur est survenue
      </h1>
      <p style={{ marginBottom: 16, color: '#6b7280' }}>
        Une erreur inattendue s&apos;est produite. Veuillez réessayer.
      </p>
      <details style={{ marginBottom: 16, padding: 12, backgroundColor: '#f3f4f6', borderRadius: 8 }}>
        <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
          Détails de l&apos;erreur (pour debug)
        </summary>
        <pre style={{ marginTop: 8, fontSize: 12, overflow: 'auto' }}>
          {error.message}
          {error.stack && `\n\nStack trace:\n${error.stack}`}
        </pre>
      </details>
      <button 
        onClick={reset}
        style={{
          backgroundColor: '#3b82f6',
          color: 'white',
          padding: '8px 16px',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 14
        }}
      >
        Réessayer
      </button>
    </div>
  )
}
